import React from 'react';
import { httpClient } from '@cocoplatform/coco-rtc-client';
import { CommunityDetails } from '@cocoplatform/coco-rtc-shared';
import { CircularProgress } from '@mui/material';
import DashboardLayout from 'components/dashboard-layout/DashboardLayout';
import { ReactChild, ReactChildren, useEffect, useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { t } from '@lingui/macro';
import { getWorldCorridorSections, SpaceSection } from 'atoms/spaces';
import UserSpacesExplorer, {
  UserSpaceSection,
} from 'components/user-spaces-explorer/UserSpacesExplorer';

export async function getCommunityByHandle(handle: string) {
  const res = await httpClient.get(`/communities/handle/${handle}`);
  return res.data;
}

// export const getWorldCorridorSections = (): SpaceSection[] => [
//   {
//     id: 'coco-jams',
//     description: t`CoCo spaces by creators around the world`,
//     horizontalDescription: t`Remix with friends to make your own.`,
//     label: 'Featured Jams',
//     altLabel: 'Featured Jams',
//     infoText: t`Jams showcase collaborative spaces shared by the CoCo Team and communities around the world. Click to explore and remix any space with friends in your community.`,
//     sortCriteria: [
//       {
//         label: t`Last Created`,
//         isDefault: true,
//         column: 'expectedToStartAt',
//         dir: 'desc',
//       },
//     ],
//     presets: [
//       {
//         id: 'all',
//         label: t`All`,
//         query: {
//           isJam: true,
//           isSpaceToRemix: true,
//           seed: 1,
//           isApproved: true,
//         },
//       },
//     ],
//   },
// ];

export default function CommunityHandlePage(p: {
  children?: ReactChild | ReactChildren;
}) {
  const { handle, spaceId } = useParams<{ handle: string; spaceId?: string }>();

  const [community, setCommunity] = useState<CommunityDetails | null>(null);
  const history = useHistory();

  useEffect(() => {
    getCommunityByHandle(handle).then((c) => {
      if (!c) {
        alert('Community not found. Please check the URL and try again.');
        history.push('/');
        return;
      }
      setCommunity(c);
    });
  }, [handle]);

  const isLoading = !community;

  return (
    <DashboardLayout
      handle={handle}
      community={community || undefined}
      isOnboarding={true}
    >
      <>
        {isLoading ? (
          <CircularProgress />
        ) : (
          <UserSpacesExplorer listQuery='' handle={handle} />
        )}
      </>
    </DashboardLayout>
  );
}
